define('modules/page_generator/views/main',['require','exports','module','backbone','base/layout','common/views/header_view_mdheader','./navigation_tabs','./variant_list','./desktop_preview','./mobile_preview','common/views/404','ldsh!../templates/main'],function (require, exports, module) {
  'use strict';
  var Backbone = require('backbone'),
    Layout = require('base/layout'),
    HeaderViewMDHeader = require('common/views/header_view_mdheader'),
    NavigationView = require('./navigation_tabs'),
    VariantListView = require('./variant_list'),
    DesktopView = require('./desktop_preview'),
    MobileView = require('./mobile_preview'),
    View404 = require('common/views/404');

  module.exports = Layout.extend({
    template: require('ldsh!../templates/main'),

    regions: {
      header: '.js-header',
      navigation: '.js-navigation',
      variantList: '.js-variant-selector',
      preview: '.js-preview-container',
    },

    initialize: function (options) {
      this.viewState = new Backbone.Model({
        step: 0,
      });

      if (options.livePreview !== undefined) {
        this.viewState.set('livePreview', options.livePreview);
      }

      if (this.model && this.collection) {
        var variantListView = new VariantListView({
          collection: this.collection,
          pageId: this.model.id,
          viewState: this.viewState,
        });

        this.regions.variantList.show(variantListView);
      }

      var headerView = new HeaderViewMDHeader();

      this.regions.header.show(headerView);

      this.listenTo(this.viewState, 'change:currentVariant', this.renderVariant);
      this.listenTo(this.viewState, 'change:currentVariant', this.renderNavigation);
      this.listenTo(this.viewState, 'change:step', this.changeTab);

      if (this.collection) {
        this.listenTo(this.collection, 'reset', this.selectVariant);
      }

      if (options.variantId) {
        this.viewState.set('variantId', options.variantId);
      }

      this.renderContent();
    },

    events: {
      'click .js-variant': 'switchVariant',
      'click .js-tab-switch': 'showStep',
    },

    renderContent: function (model, response) {
      this.globalVars = response && response.global ? response.global : [];
      this.fetchModel();
    },

    fetchModel: function () {
      var self = (window.LPGPreview = this);
      if (this.model) {
        this.model.fetch({
          success: function () {
            self.collection.fetch({ reset: true });
          },
          error: function () {
            self.regions.preview.show(new View404());
          },
        });
      }
    },

    switchVariant: function (e) {
      e.preventDefault();
      var variantId = this.$(e.currentTarget).data('variant-id');
      this.viewState.set('currentVariant', this.collection.get(parseInt(variantId)));
    },

    showStep: function (e) {
      e.preventDefault();
      var el = this.$(e.currentTarget),
        step = +el.data('step');
      this.viewState.set('step', step);
    },

    changeTab: function (model, activeStep) {
      this.$('.js-tab-switch:not([data-step=' + activeStep + '])')
        .parent()
        .removeClass('active');
      this.$('.js-tab-switch[data-step=' + activeStep + ']')
        .parent()
        .addClass('active');

      //render same variant, different tab
      this.renderVariant(model, this.viewState.get('currentVariant'));
    },

    selectVariant: function () {
      var variantId = this.viewState.get('variantId');
      if (variantId) {
        this.viewState.set('currentVariant', this.collection.get(variantId));
      } else {
        this.viewState.set('currentVariant', this.collection.first());
      }
    },

    helpers: function () {
      var currentVariant;
      if (this.viewState.has('currentVariant')) {
        currentVariant = this.viewState.get('currentVariant').toJSON();
      } else {
        currentVariant = {};
      }

      return {
        variants: this.collection ? this.collection.toJSON() : [],
        currentVariant: currentVariant,
        id: this.model ? this.model.id : 0,
      };
    },

    onRender: function () {
      this.$el.i18n();
      if (this.viewState.get('livePreview') && window.opener && window.opener.MVariant) {
        var self = this;

        setTimeout(function () {
          self.viewState.set('currentVariant', window.opener.MVariant);
        }, 200);
      }
    },

    renderNavigation: function (model, variant) {
      this.regions.navigation.show(
        new NavigationView({
          collection: variant.content,
        })
      );
    },

    renderVariant: function (model, variant) {
      var self = this,
        VariantPreview,
        variantToRender = variant,
        variantParams = {
          model: variantToRender,
        };

      if (!variantToRender) {
        return false;
      }

      variantToRender.set('globalVars', this.globalVars);
      variantToRender.set('full_url', this.model.get('full_url'));

      if (variantToRender.get('platform') === 'desktop') {
        self.$('.js-preview-container').removeClass('mobile-preview');
        self.$('.js-preview-container').addClass('desktop-preview');
        VariantPreview = new DesktopView(variantParams);
      } else {
        self.$('.js-preview-container').addClass('mobile-preview');
        self.$('.js-preview-container').removeClass('desktop-preview');
        VariantPreview = new MobileView(variantParams);
      }

      self.regions.preview.show(VariantPreview);
      VariantPreview.renderContents(self.viewState.get('step'));
    },
  });
});

